const ALLOWED_TAGS = [
  'a',
  'b',
  'br',
  'div',
  'em',
  'h2',
  'h3',
  'h4',
  'i',
  'img',
  'li',
  'ol',
  'p',
  'span',
  'strong',
  'u',
  'ul'
]

const ALLOWED_ATTRS = {
  a: ['href', 'title', 'target', 'rel'],
  img: ['src', 'alt', 'title']
}

function isSafeUrl (value) {
  if (!value) return false
  try {
    const url = new URL(value, window.location.origin)
    return url.protocol === 'http:' || url.protocol === 'https:'
  } catch (error) {
    return false
  }
}

function unwrapNode (node) {
  const parent = node.parentNode
  if (!parent) return
  while (node.firstChild) {
    parent.insertBefore(node.firstChild, node)
  }
  parent.removeChild(node)
}

export function sanitizeRulesHtml (html) {
  if (!html) return ''
  const parser = new DOMParser()
  const doc = parser.parseFromString('<div id="wc-quiz-rules-root"></div>', 'text/html')
  const root = doc.getElementById('wc-quiz-rules-root')
  if (!root) return ''
  root.innerHTML = html

  Array.prototype.slice.call(root.querySelectorAll('script,iframe,object,embed,style,link,meta,svg,math')).forEach(node => node.remove())

  // 仅处理内容容器内的节点，且自底向上 unwrap，避免 WebKit 报 incorrect node tree。
  const nodes = Array.prototype.slice.call(root.querySelectorAll('*')).reverse()
  nodes.forEach(node => {
    const tag = node.tagName.toLowerCase()
    if (ALLOWED_TAGS.indexOf(tag) === -1) {
      unwrapNode(node)
      return
    }
    const allowedAttrs = ALLOWED_ATTRS[tag] || []
    Array.prototype.slice.call(node.attributes).forEach(attr => {
      const name = attr.name.toLowerCase()
      const value = attr.value || ''
      if (allowedAttrs.indexOf(name) === -1 || name.indexOf('on') === 0 || /javascript:/i.test(value)) {
        node.removeAttribute(attr.name)
        return
      }
      if ((name === 'href' || name === 'src') && !isSafeUrl(value)) {
        node.removeAttribute(attr.name)
      }
    })
    if (tag === 'a') {
      node.setAttribute('rel', 'noopener noreferrer')
    }
  })

  return root.innerHTML
}
